import { TFunction } from 'i18next';

export const HomePageSidebarKey = 'home';
export const HomePagePath = '/home';
export const getHomePageTitle = (t: TFunction): string =>
  t('sidebar:home', 'Home');
